import React from 'react';

/**
 * The white panel every block on both pages sits in.
 *
 * One component because the design draws one card: a 0.876px hairline in
 * border/default, a 15.325px radius, and the file's own "Card Shadow" — both
 * of its layers, which `v2-card` already carries for the landing's comparison
 * table.
 *
 * The odd numbers are the design's, not a rounding: the student frames are
 * drawn at a scale where 16px lands on 15.325 and 1px on 0.876. They are
 * written as arbitrary values rather than added to the theme, per the note at
 * the foot of `shared/styles/base.css` — the app's 14px root would otherwise
 * turn a named `rounded-2xl` into 21px.
 *
 * `as` exists for the two places the card is a <section> with a heading of its
 * own, so the page keeps a landmark structure a screen reader can move through.
 */
const Card = ({ as: Tag = 'div', className = '', children, ...rest }) => (
    <Tag
        className={
            'tw-bg-white tw-border-[0.876px] tw-border-solid tw-border-v2-neutral-200 ' +
            `tw-rounded-[15.325px] tw-shadow-v2-card ${className}`
        }
        {...rest}
    >
        {children}
    </Tag>
);

export default Card;
